import API from './api';

export const tripAnalyticsService = {
  async getAllAnalytics(startDate, endDate, userId = null) {
    try {
      console.log('🔵 Calling API with params:', { startDate, endDate, userId });

      const params = { startDate, endDate };
      if (userId) params.userId = userId;

      // ✅ Increase timeout to 60 seconds for this specific call
      const response = await API.get('/api/trips/admin/trip-analytics/all', { 
        params,
        timeout: 60000 // 60 seconds
      });

      console.log('🔵 API Response:', response);

      if (response.data && response.data.success && response.data.data) {
        return {
          success: true,
          data: response.data.data
        };
      }

      if (response.data && response.data.success === false) {
        return {
          success: false,
          message: response.data.message || 'Failed to fetch trip analytics'
        };
      }

      return {
        success: false,
        message: 'Unexpected response format from server'
      };

    } catch (error) {
      console.error('❌ Trip Analytics Service Error:', error);
      console.error('❌ Error Response:', error.response);
      
      // Better error messages for timeout
      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        return {
          success: false,
          message: 'Request timeout. The server is taking too long to respond. Try a smaller date range.'
        };
      }
      
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to fetch trip analytics',
        error: error.response?.data
      };
    }
  },

  async getMetrics(startDate, endDate, userId = null) {
    try {
      const params = { startDate, endDate };
      if (userId) params.userId = userId;

      const response = await API.get('/api/trips/admin/trip-analytics/metrics', { 
        params,
        timeout: 60000 
      });
      
      if (response.data && response.data.success) {
        return { success: true, data: response.data.data };
      }
      
      return { 
        success: false, 
        message: response.data?.message || 'Failed to fetch metrics' 
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch metrics'
      };
    }
  },

  async getAllMembers() {
    try {
      const response = await API.get('/api/trips/admin/trip-analytics/members', {
        timeout: 60000
      });
      
      if (response.data && response.data.success) {
        return { success: true, data: response.data.data };
      }
      
      return { 
        success: false, 
        message: response.data?.message || 'Failed to fetch members' 
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch members'
      };
    }
  }
};

export default tripAnalyticsService;
